// src/components/redirect-banner/redirect-banner.tsx
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  query RedirectBannerQuery($context: ContextInput!, $pageSearch: String) {\n    redirectBanner(context: $context, pageSearch: $pageSearch) {\n      banner {\n        message\n        fullWidth\n        egdsElementId\n      }\n      inlineLink {\n        text\n        action {\n          resource {\n            value\n          }\n          analytics {\n            referrerId\n            linkName\n          }\n          target\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import React from "react";
import { useLocation } from "react-router-dom";
import { gql, useQuery } from "@apollo/client";
import { EGDSBanner } from "@egds/react-core/banner";
import { EGDSLink } from "@egds/react-core/link";
import { EGDSSpacing } from "@egds/react-core/spacing";
import { EGDSText } from "@egds/react-core/text";
import { useBexApi } from "@shared-ui/bex-api-context";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
var __Query = gql(_templateObject());
var RedirectBanner = function(param) {
    var skipSsr = param.skipSsr;
    var context = useBexApi().context;
    var _useLocation = useLocation(), pageSearch = _useLocation.search;
    var clickTracker = useClickTracker();
    var variables = {
        context: context,
        pageSearch: pageSearch
    };
    var _useQuery = useQuery(__Query, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    if (loading || error || !data || !data.redirectBanner) {
        return null;
    }
    var _data_redirectBanner = data.redirectBanner, banner = _data_redirectBanner.banner, inlineLink = _data_redirectBanner.inlineLink;
    return /* @__PURE__ */ React.createElement(EGDSBanner, {
        fullWidth: banner.fullWidth === true
    }, /* @__PURE__ */ React.createElement(EGDSSpacing, {
        margin: {
            block: "one"
        },
        padding: {
            small: {
                inlinestart: "three"
            },
            large: {
                inlinestart: "six"
            }
        }
    }, /* @__PURE__ */ React.createElement(EGDSText, {
        theme: "inverse"
    }, banner.message, "\xA0", inlineLink && /* @__PURE__ */ React.createElement(EGDSLink, {
        inline: true,
        onClick: function() {
            return clickTracker(inlineLink.action.analytics.referrerId, inlineLink.action.analytics.linkName);
        },
        theme: "inverse"
    }, /* @__PURE__ */ React.createElement("a", {
        href: inlineLink.action.resource.value,
        target: "_self"
    }, inlineLink.text)))));
};
RedirectBanner.displayName = "sharedui-RedirectBanner";
export { RedirectBanner };
//# sourceMappingURL=index.js.map